import React from 'react';
import { TablePagination } from '@mui/material';

interface PaginationControlsProps {
    total: number;
    rowsPerPage: number;
    currentPage: number;
    handleRowsPerPage: (value: number) => void;
    handlePageChange: (page: number) => void;
    hideRowsPerPage?: boolean;
};

export const PaginationControls: React.FC<PaginationControlsProps> = ({
    total,
    rowsPerPage,
    currentPage,
    handleRowsPerPage,
    handlePageChange,
    hideRowsPerPage = false,
}) => {
    return (
        <TablePagination
            component="div"
            key={total}
            count={total}
            page={currentPage - 1}
            onPageChange={(_, newPage) => handlePageChange(newPage + 1)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(event) => {
                handleRowsPerPage(parseInt(event.target.value, 10));
                handlePageChange(1);
            }}
            rowsPerPageOptions={hideRowsPerPage ? [] : [5, 10, 25, 50, 100]}
        />
    );
};